import { FeatureValue } from "./featureValue";
import { PRODUCT } from "../store/variables";

export class Product {
  id: number;
  identifier: string;
  name: string;
  minDate: string;
  maxDate: string;
  price: string;
  final: boolean;
  featureValues: FeatureValue[];
  downGradeOptions: Array<number>;

  constructor(product: any) {
    this.id = product.id;
    this.identifier = product.identifier;
    this.name = product.name;
    this.minDate = product.max_age;
    this.maxDate = product.min_age;
    this.price = product.rates.length ? product.rates[0].price : undefined;
    this.final = product.rates.length === 1 || !this.price;
    this.featureValues = product.featureValues?.map(
      (featureValue: any) => new FeatureValue(featureValue)
    );
    this.downGradeOptions = this.getDownGradeOptions(product);
  }

  getDownGradeOptions(product: any): Array<number> {
    const downGradeOptions: Array<number> = [];
    product.sellRelation?.forEach((sellRelation: any) => {
      if (sellRelation?.relation_type === "down") {
        downGradeOptions.push(sellRelation.related_product_id);
      }
    });
    return downGradeOptions;
  }

  getFeatureValue(id: number): FeatureValue | undefined {
    return this.featureValues.find(
      (featureValue: FeatureValue): boolean => featureValue.id === id
    );
  }

  getDisplayNameDesktop(): string {
    switch (this.identifier) {
      case PRODUCT.TKS24:
      case PRODUCT.TKS:
      case PRODUCT.TKSE:
      case PRODUCT.OPS24:
      case PRODUCT.OPS:
      case PRODUCT.OPSE:
        return this.name;
      case PRODUCT.HPS24:
        return "Hundehaftpflicht 24";
      case PRODUCT.HPS:
        return "Hundehaftpflicht";
      case PRODUCT.HPSE:
        return "Hundehaftpflicht Exklusiv";
      default:
        return "";
    }
  }

  getDisplayNameMobile(): string {
    switch (this.identifier) {
      case PRODUCT.TKS24:
        return "TKS 24";
      case PRODUCT.TKS:
        return "TK Schutz";
      case PRODUCT.TKSE:
        return "TKS Exklusiv";
      case PRODUCT.OPS24:
        return "OPS 24";
      case PRODUCT.OPS:
        return "OP Schutz";
      case PRODUCT.OPSE:
        return "OPS Exklusiv";
      case PRODUCT.HPS24:
        return "HPS 24";
      case PRODUCT.HPS:
        return "HP Schutz";
      case PRODUCT.HPSE:
        return "HPS Exklusiv";
      default:
        return "";
    }
  }

  getUrlName(): string {
    return this.getDisplayNameDesktop().toLowerCase().replace(" ", "-");
  }

  getDisplayPrice(): string {
    return this.price?.replace(".", ",") + "€";
  }

  getErrorMessage(selectedDate: Date): string {
    if (selectedDate > new Date(this.maxDate)) {
      return "Mindestalter 8 Wochen";
    } else {
      return "Altersgrenze erreicht";
    }
  }
}
